const MAXIMAL_ZOOM = 3;
const MODES = {
  EDIT: 'drag',
  BRIGHTNESS: 'brightness',
  STRAIGHTEN: 'straighten',
  CROP: 'crop-zoom',
  ROTATE: 'rotate',
  FILTERS: 'filters',
};

const DEFAULT_MODE = MODES.CROP;

const EDIT_HEADER_TITLES = {
  rotate: 'Rotate',
  brightness: 'Brightness',
  straighten: 'Tilt',
  'crop-zoom': 'Crop & Zoom',
  filters: 'Filters',
};

const INITIAL_MIN_ZOOM = 1;

export {
  MODES,
  MAXIMAL_ZOOM,
  EDIT_HEADER_TITLES,
  DEFAULT_MODE,
  INITIAL_MIN_ZOOM,
};
